/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-07-18 11:08:46
 */
import React, { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { getBasicInfo } from 'root/services/monitor';
import { FormComponentProps } from 'sup-ui/lib/form/Form';
import EditSysTime from 'root/components/EditSysTime';
import { updatePlatformTimeApi } from 'root/services/netWork';
import { message } from 'sup-ui';
import messages from './messages';
import List from './components/List';
import styles from './index.less';
import Icon from 'root/components/Icon';
import moment from 'moment';
import 'moment-timezone';
import { getSuposStatusApi } from 'root/services/manager';

type Ref = FormComponentProps;
let loopTimer: any = null;

const SysNoSupOS = () => {
  const intl = useIntl();
  const [sysTimeData, setSysTimeData] = useState({}); // 修改系统时间传默认对象
  const [baseInfo, setBaseInfo] = useState<any>({}); //  基本信息
  const [formList, setFormList] = useState([0]); // 多个ntp服务器
  const EditSysTimeRef = useRef<Ref>();
  const [visibleSysTime, setVisibleSysTime] = useState(false);
  const [init, setInit] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const unmountedRef = useRef(false); // 用于标记页面卸载

  useEffect(() => {
    if (!sessionStorage.getItem('runtimeEnvId')) return;
    getData();
    getStatus();
    checkInit();
    return () => {
      clearTimeout(loopTimer);
      loopTimer = null;
    };
  }, []);

  useEffect(() => {
    checkInit();
  }, [visibleSysTime]);

  // 获取运行状态
  const getStatus = () => {
    getSuposStatusApi({ names: ['supos'] }).then((res: any) => {
      const { data = [{}] } = res;
      const { status } = data[0];

      // 监测supos状态，如果是运行中 刷新页面
      if (status === 'RUNNING') {
        const str = sessionStorage.getItem('envStatus') || '';
        const envStatus = JSON.parse(str) || {};
        sessionStorage.setItem('envStatus', JSON.stringify({ ...envStatus, isSuposInstalled: true }));
        window.hashHistory.push('/instances');
        return;
      }
      loopGetData();
    });
  };

  // 轮询获取状态
  const loopGetData = () => {
    if (unmountedRef.current) return;
    clearTimeout(loopTimer);

    loopTimer = setTimeout(() => {
      getStatus();
    }, 1000 * 10);
  };
  // 获取平台信息
  const getData = () => {
    getBasicInfo().then((res: any) => {
      const { data } = res;
      const { auto, systemTime, timezone, ntpIP = [] } = data.timeInfo;
      setBaseInfo(data.timeInfo);

      setSysTimeData({
        timezone,
        isAuto: auto ? 1 : 0,
        systemTime: systemTime,
        ntpIP,
      });
      if (ntpIP?.length) setFormList(ntpIP.map((item: any, index: number) => index));
    });
  };

  // 关闭系统时间设置
  const handSysTimeCancel = () => {
    setVisibleSysTime(false);
    setInit(false);
  };
  // 检测是否首次进入页面
  const checkInit = () => {
    const initFlag = sessionStorage.getItem('init');
    if (!initFlag) {
      setInit(true);
      setVisibleSysTime(true);
      sessionStorage.setItem('init', '1');
      return;
    }
  };
  // 修改系统时间
  const handSysTimeSubmit = () => {
    setInit(false);
    EditSysTimeRef?.current?.form.validateFields((err: any, values: any) => {
      if (err) return;
      const { isAuto, timezone, ntp } = values;
      const tempNtp = ntp?.filter((item: string) => item);
      const params = {
        timezone,
        isAuto,
        value: isAuto ? tempNtp : moment(values.date).tz(timezone).valueOf(),
      };
      setSpinning(true);
      updatePlatformTimeApi(params)
        .then(() => {
          message.success(intl.formatMessage(messages.success));
          setVisibleSysTime(false);
          setFormList([0]);
          // 解决同步时间后端后延迟
          if (isAuto) {
            setTimeout(() => {
              getData();
            }, 1000);
            return;
          }
          getData();
        })
        .finally(() => {
          setSpinning(false);
        });
    });
  };

  return (
    <div className={styles.package_manage}>
      <div className={styles.serverTime}>
        <span>{intl.formatMessage(messages.serverTime)}</span>
        <div className={styles.time}>
          {baseInfo.systemTime
            ? moment(baseInfo.systemTime).tz(baseInfo.timezone).format('YYYY[年]MM[月]DD[日] HH:mm')
            : ''}
          <EditSysTime
            wrappedComponentRef={EditSysTimeRef}
            visible={visibleSysTime}
            onCancel={handSysTimeCancel}
            onOk={handSysTimeSubmit}
            record={sysTimeData}
            setFormList={setFormList}
            formList={formList}
            init={init}
            spinning={spinning}
          />
          {baseInfo.systemTime && (
            <Icon
              type="edit161"
              className={styles.editIcon}
              onClick={() => {
                getData();
                setVisibleSysTime(true);
              }}
            />
          )}
        </div>
      </div>
      <div className={styles.packList}>
        <List />
      </div>
    </div>
  );
};

export default SysNoSupOS;
